
import { mapState, mapActions } from "vuex";
import { createWidget } from "@typeform/embed";
import "@typeform/embed/build/css/widget.css";
const FORM_ID = "htoX0hBc";
const charLength = Math.ceil(window.innerWidth / 7);

export default {
  props: {
    notification: {
      type: Object,
      default: () => {}
    },

    loading: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showFullText: false
    };
  },

  computed: {
    ...mapState("restaurant", ["locationDetails", "showFeedback"]),
    hasShowMore() {
      return charLength < this.notification.message.length;
    }
  },
  methods: {
    getText() {
      return this.showFullText || !this.hasShowMore
        ? this.notification.message
        : `${this.notification.message.slice(0, charLength)}...`;
    }
  }
};
